import {useParams} from "react-router-dom";
import {Fragment, useEffect, useMemo, useState} from "react";
import {UpdateOrderComponent} from "../../component/UpdateOrderComponent";
import {Layout} from "../../component/layout/Layout";
import {get, post, put} from "../../js/api";
import {OrderInformation} from "../../component/OrderInformation";
import {AddressInput, empty as emptyAddress} from "../../component/form/AddressInput";
import {InputCheckbox} from "../../component/form/InputCheckbox";
import {Button} from "../../component/form/Button";
import {WorkflowProgress} from "../../component/layout/WorkflowProgress";
import {orderType} from "../../js/constants";
import {OrderCorrespondence} from "../../component/OrderCorrespondence";
import {showMessage} from "../../js/main";
import {RefreshSignal, useChangeEffect} from "../../js/util";

const refresh = new RefreshSignal();

export const UpdatePublicOrder = ({}) => {

    const {token} = useParams();

    const [useBillingAddressForShipping, setUseBillingAddressForShipping] = useState(true);
    const [billingAddress, setBillingAddress] = useState(null);
    const [shippingAddress, setShippingAddress] = useState(emptyAddress);
    const [selectedOrder, setSelectedOrder] = useState(null);

    const [reply, setReply] = useState(null);

    const [submitting, setSubmitting] = useState(false);

    const [currentStep, setCurrentStep] = useState();
    const workflowSteps = useMemo(() => ["Start", "Kontaktdaten angeben", "Bestätigung"]);

    useEffect(() => {
        get(`/public/orders/${token}`).then((order) => {
            if(order.type == orderType.request){
                window.location = `http://guest-request/${token}`;
            }
            setSelectedOrder(order);
            const withEmail = {...billingAddress, email: order.email}; //prefill with info we have
            setBillingAddress(withEmail);
        })
    }, []);

    useEffect(() => {
        if(!selectedOrder){
            return;
        }
        if(selectedOrder.billingAddress){
            setCurrentStep(workflowSteps[2]);
        }else {
            setCurrentStep(workflowSteps[1]);
        }
    }, [selectedOrder])

    useChangeEffect(() => {
        if(currentStep == 'Bestätigung' && selectedOrder.state == 'CREATED'){
            requestNewTan();
        }
    }, [currentStep])

    const requestNewTan = () => {
        setSubmitting(true);
        post(`/public/orders/${selectedOrder.id}/requestNewTan`).then(() => {
            showMessage("Neuer Code wurde erfolgreich versendet.");
        }).finally(() => {
            setSubmitting(false);
        });
    };

    const saveAddresses = () => {
       const updates = {...selectedOrder, billingAddress: billingAddress, shippingAddress: useBillingAddressForShipping ? null : shippingAddress};

       put(`/public/orders/${token}/updateAddresses`, updates).then((updatedOrder) => {
           setSelectedOrder(updatedOrder);
       });
    }

    const sendReply = () => {
        post(`/public/orders/${token}/correspondence`, reply).then(() => {
           showMessage("Die Nachricht wurde gesendet");
            refresh.changed();
            if(selectedOrder.state == 'AWAIT_USER'){
                get(`/public/orders/${token}`).then(setSelectedOrder);
            }
        });
    }


    return (
        <>
            <Layout username={null}>
                <WorkflowProgress steps={workflowSteps} currentStep={currentStep}></WorkflowProgress>
                {selectedOrder && <>
                    {workflowSteps.indexOf(currentStep) == 1 && billingAddress && <>
                        <form onSubmit={(e) => {
                            e.preventDefault();
                            saveAddresses();
                        }}>
                            <h1>Offenes Bestellungsangebot {selectedOrder.id}</h1>
                            <p>Wir freuen uns, Ihnen das folgende Angebot machen zu können. Wenn Sie mit dem Angebot
                                einverstanden sind, benötigen wir nur noch Ihre Kontaktdaten von Ihnen.</p>
                            <h2>Bestellungsangebot</h2>
                            <OrderInformation order={selectedOrder} hideHeader/>
                            <h2 className="mt-2 mb-05">Rechnungsadresse auswählen</h2>
                            <AddressInput initial={billingAddress}
                                          setter={setBillingAddress}
                                          type={useBillingAddressForShipping ? 'BOTH' : 'BILLING'}></AddressInput>
                            <div className="default mb-1">
                                <InputCheckbox label="Lieferadresse entspricht Rechnungsadresse"
                                               big
                                               value={useBillingAddressForShipping}
                                               setter={(newValue) => setUseBillingAddressForShipping(newValue)}/>
                            </div>
                            {!useBillingAddressForShipping &&
                                <AddressInput initial={shippingAddress}
                                              setter={setShippingAddress}
                                              type="SHIPPING"
                                              optionals/>}

                            <div className={"safe-actions mt-1"}>
                                <Button key="submit" theme="primary-button mb-1" width={230}
                                        submitting={submitting}>weiter</Button>
                            </div>
                        </form>
                    </>}

                    {workflowSteps.indexOf(currentStep) == 2 && <>
                        <UpdateOrderComponent identifier={token} token={true}></UpdateOrderComponent>
                    </>}
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        sendReply();
                    }}>
                        <OrderCorrespondence isPublic={true} identifier={token} onCreateReply={setReply} adminView={false} refresh={refresh}/>
                        {reply &&  <div className={"safe-actions mt-1"}>
                            <Button key="submit" theme="blue mb-1"
                                                                                width={230}
                                                                                submitting={submitting}>Antwort
                                senden</Button>
                        </div>}
                        </form>
                            </>}
            </Layout>
        </>
    );

};